import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { AccessControlController } from '@shared/src/controllers/accesscontrol/accesscontrol.controller';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { ForkliftRouteDetailDto } from '@shared/src/dtos/accesscontrol/forklift/ForkliftRouteDetailDto';

@Component({
    selector: 'shared-forklift-right-actions',
    templateUrl: './shared.forklift.right.actions.component.html',
    styleUrls: ['./shared.forklift.right.actions.component.scss']
})
export class SharedForkliftRightActionsComponent {

    constructor(private accessControlController: AccessControlController,
        @Inject('HomeController') private homeController: HomeController) { }

    @Output() public refresh = new EventEmitter<boolean>();
    @Output() public phaseChanged = new EventEmitter<number>();
    @Input() public detail: ForkliftRouteDetailDto | null = null;
    @Input() public accessControlId: number | null = null;

    onRefresh() {
        this.refresh.next(true);
    }

}
